var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgNavUserMobile = function SvgNavUserMobile(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    style: {
      enableBackground: "new 0 0 48 48"
    },
    xmlSpace: "preserve"
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", null, ".nav_user_mobile_svg__st0{fill:none;stroke:#231f20;stroke-width:1.3;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10}")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "nav_user_mobile_svg__Layer_2"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "nav_user_mobile_svg__st0",
    cx: 24.3,
    cy: 20.8,
    r: 5.7
  }), /*#__PURE__*/React.createElement("path", {
    className: "nav_user_mobile_svg__st0",
    d: "M16.5 35.4c0-4.9 3.4-8.8 7.7-8.8M31.7 35.4c0-4.9-3.4-8.8-7.5-8.8"
  }))));
};
export default SvgNavUserMobile;